<template>
  <div class="flex h-full min-h-0 relative">
    <div
      v-if="hasReservationSubscription"
      class="sm:h-full w-14 bg-n-900 flex sm:flex-col items-center p-2 gap-4 border-t border-n-800"
      :class="{
        'absolute top-0 left-0 z-20': isMobile
      }"
    >
      <router-link :to="{ name: 'reservationsList' }" v-slot="{ isActive, navigate }">
        <l-button
          size="small"
          icon="list"
          :color="isActive ? 'green' : 'white'"
          :type="isActive ? 'primary' : 'text'"
          @click="navigate()"
        />
      </router-link>
      <router-link :to="{ name: 'reservationsTimeline' }" v-slot="{ isActive, navigate }">
        <l-button
          size="small"
          icon="align-left"
          :color="isActive ? 'green' : 'white'"
          :type="isActive ? 'primary' : 'text'"
          @click="navigate()"
        />
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { RouterLink } from 'vue-router'

import { LButton } from '@last/core-ui/paprika'

import { useAuthStore } from '@/store/auth'
import { isMobile } from '@/utils/device-type'

const authStore = useAuthStore()

const { hasReservationSubscription } = storeToRefs(authStore)
</script>
